import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  ActiveInactiveTeamMember,
  deleteTeamMember,
  getAllTeamMembers,
} from "./services/teamMember.services";
import { clearTeamMemberID, setTeamMemberID } from "./teamMemberSlice";
import ButtonCreate from "../../components/muidrawer/ButtonCreate";
import ButtonEdit from "../../components/muidrawer/ButtonEdit";
import { Tooltip } from "@mui/material";
import { FaGraduationCap } from "react-icons/fa6";
import ExpandableText from "../../components/common/ExpandableText";

const TeamMember: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  // const handleCreate = () => {
  //   navigate("/teamMember/create");
  // };

  useEffect(() => {
    dispatch(getAllTeamMembers());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteTeamMemberDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Team Member List
          </Typography.h4>
          {isAddAccess && (
            // <Button
            //   onClick={handleCreate}
            //   fillMode={"solid"}
            //   themeColor={"primary"}
            // >
            //   {"Create TeamMember"}
            // </Button>
            <ButtonCreate
              label="Create Team Member"
              drawerName="teamMemberForm"
              drawerWidth={700}
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <TeamMemberGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const TeamMemberGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const TeamMemberList = useAppSelector(
    (state) => state.teammember.TeamMemberList
  );
  const loading = useAppSelector((state) => state.teammember.loading);

  useEffect(() => {
    dispatch(getAllTeamMembers());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? TeamMemberList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    // const handleEdit = (ID: number) => {
    //   navigate("/teamMember/edit", { state: { TeamMemberID: ID } });
    // };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteTeamMember"));
      dispatch(setTeamMemberID(ID));
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          // <IconButton
          //   type="button"
          //   fillMode="flat"
          //   size="small"
          //   title="Edit"
          //   onClick={() => handleEdit(props.dataItem.ID)}
          // >
          //   <FiEdit
          //     className="absolute-position"
          //     style={{ fontSize: "20px" }}
          //   />
          // </IconButton>
          <ButtonEdit
            ID={props.dataItem.ID}
            name="teamMemberForm"
            tooltipTitle="Edit"
            drawerWidth={700}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 2 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive ?? false
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveTeamMember(data)).then((response: any) => {
        // dispatch(getAllTeamMembers());
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllTeamMembers());
        } else {
          dispatch(getAllTeamMembers());
        }
      });
    };

    return (
      <td
        style={{ textAlign: "center", ...props.style }}
        className={props.className}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {TeamMemberList && TeamMemberList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          className="responsive-table"
          data={
            filter
              ? filterBy(TeamMemberList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : TeamMemberList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={TeamMemberList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Name"
            title="Name"
            width={150}
            cell={(props: any) => (
              <td>
                <div className="hoverableName">
                  {isEditAccess ? (
                    <ButtonEdit
                      ID={props.dataItem.ID}
                      name="teamMemberForm"
                      label={props.dataItem?.Name}
                      drawerWidth={700}
                    />
                  ) : (
                    <div className="normalName">{props.dataItem?.Name}</div>
                  )}
                </div>
              </td>
            )}
          />
          <Column field="Title" title="Title" width={"150px"} />

          <Column
            field="Message"
            title="Message"
            width={300}
            cells={{
              data: (props) =>
                props.dataItem.Message ? (
                  <ExpandableText text={props.dataItem.Message} />
                ) : (
                  <td></td>
                ),
            }}
          />
          <Column
            field="Image"
            title="Image"
            width={100}
            filterable={false}
            cell={(props: any) => (
              <td style={{ textAlign: "center" }}>
                <Avatar
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    flexBasis: 45,
                    backgroundColor: "white",
                  }}
                  rounded={"medium"}
                  type={"image"}
                >
                  <Tooltip
                    placement="left"
                    title={
                      <img
                        style={{
                          padding: "5px",
                          backgroundColor: "white",
                          height: 150,
                        }}
                        src={props.dataItem?.Image}
                        alt="Team Member Image"
                        width="100%"
                        onClick={() => window.open(props.dataItem?.Image)}
                      />
                    }
                  >
                    {props.dataItem?.Image ? (
                      <img
                        style={{ padding: "10px" }}
                        src={props.dataItem?.Image}
                        alt="TeamMember Image"
                        onClick={() => window.open(props.dataItem?.Image)}
                      />
                    ) : (
                      <>
                        <FaGraduationCap
                          style={{
                            fontSize: "50px",
                            background: "lightgray",
                            padding: "5px",
                            borderRadius: "4px",
                            color: "#163064",
                          }}
                        />
                      </>
                    )}
                  </Tooltip>
                </Avatar>
              </td>
            )}
          />
          <Column
            field="ID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              locked={true}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteTeamMemberDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const TeamMemberID = useAppSelector((state) => state.teammember.TeamMemberID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteTeamMember(ID));
      if (response.payload?.Data?.Status === 200) {
        dispatch(getAllTeamMembers());
        dispatch(closeDialog());
        dispatch(clearTeamMemberID());
      } else {
        dispatch(getAllTeamMembers());
        dispatch(closeDialog());
        dispatch(clearTeamMemberID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteTeamMember" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete TeamMember"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Team Member ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TeamMemberID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default TeamMember;
